import { IAttribute, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { Component, Input, Output } from 'angular-ts-decorators';
import { getColorStyles } from 'src/Foundation/Design/platform/app/utils/get-color-styles';

import { CustomizerFilter, FilterOption, OnFilterChangeHandler } from '../../models';

import { HeroCustomizerV2FilterRadioComponent } from './hero-customizer-v2.filter-radio.component';

import template from './hero-customizer-v2.filter-color.component.html';

@Component({
  selector: 'heroCustomizerV2FilterColor',
  template,
})
export class HeroCustomizerV2FilterColorComponent extends HeroCustomizerV2FilterRadioComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public groups?: IProductWithAttributes[];
  @Input() public filter?: CustomizerFilter;
  @Input() public showColorsAsDots?: boolean;

  @Output() public onFilterChange?: OnFilterChangeHandler;

  public getColorStyles = getColorStyles;

  public getOptionImage(option: FilterOption): string | undefined {
    const optionGroup = this.getOptionGroup(option);
    return optionGroup ? optionGroup.images[0].url : undefined;
  }

  public getOptionImageAlt(option: FilterOption): string | undefined {
    const optionGroup = this.getOptionGroup(option);
    return optionGroup ? optionGroup.productName : undefined;
  }

  private getOptionGroup(option: FilterOption): IProductWithAttributes {
    return this.groups.filter((g: IProductWithAttributes) => {
      return g.attributes.some((a: IAttribute) => (a.key === this.filter.name && a.valueKey === option.value));
    })[0];
  }
}
